import api from './_api';
import Vue from 'vue'

const postForm= async (context,payload) => {    
    let result=payload.payload
    let id=payload.id      
    try{        
        var response = await api.postForm(result,id)
        if (response) {              
            await context.dispatch('getAll');
            context.commit('COMPANYCATEGORY_SET_DUPLICATE', false)
            return response
        }
    }
    catch(error)  { 
        
        return Promise.reject(error);;
    };    
};
        
const getAll = async (context) => {
    try {
        var response = await api.fetchAll()                
        context.commit('COMPANYCATEGORY_SET_COMPANYCATEGORIES',response.data)        
        return response.data
    }
    catch(error) {                        
        return Promise.reject(error);
    };    
};

const getById = async (context,payload) => {
    try {        
        var response = await api.getById(payload)                
        context.commit('COMPANYCATEGORY_SET_COMPANYCATEGORY',response.data)           
        return response.data
    }
    catch(error) {                        
        return Promise.reject(error);
    };   
};
const deleteById = async (context,payload) => {
    
    try {             
        var response = await api.deleteById(payload)     
        await context.dispatch('getAll')           
        return response.data
    }
    catch(error) {   
        //alert(error)                          
        return Promise.reject(error);
    };    
};



export default {
  getAll,
  postForm,
  getById,
  deleteById
};

